import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import translate from '../TranslateHOC';

class MyS4CUnAuthNav extends Component {

	render() {
		const { strings, active } = this.props;
		const qs = window.location.search;

		return (
			<div className="sub-header">
				 <div className="my-s4c-header">
					 <nav className="my-s4c-header__nav my-s4c-header__nav--unauth">
						 <ul className="my-s4c-header__list">
							 {/*<li className="my-s4c-header__item">
								 <Link className={ "my-s4c-header__link" + (active === "/MyS4C/SignIn" || (active !== "/MyS4C/SignUp" && active !== "/MyS4C/Verify") ? " my-s4c-header__link--active": "") }  to="/MyS4C/SignIn">
									 {strings.logIn}
								 </Link>
							 </li>*/}
							 <li className="my-s4c-header__item">
								 <Link className={ "my-s4c-header__link" + (active === "/MyS4C/SignIn" ? " my-s4c-header__link--active": "") }  to={"/MyS4C/SignIn" + qs} >
									 {strings.logIn}
								 </Link>
							 </li>
							 <li className="my-s4c-header__item">
								 <Link className={ "my-s4c-header__link" + (active === "/MyS4C/SignUp" || active === "/MyS4C/SignUpB" || active === "/MyS4C/Verify" ? " my-s4c-header__link--active": "") } to={"/MyS4C/SignUp" + qs}>
									 {strings.register}
								 </Link>
							 </li>
						 </ul>
					 </nav>
				 </div>
			</div>
		);
	}
}

export default translate(MyS4CUnAuthNav);
